import { useState, useRef } from "react";
import { toast } from "sonner";
import { Loader2, FileUp } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export function ImportCsvDialog({ open, onOpenChange, campaignId, onDone }) {
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);
  const inputRef = useRef();

  const submit = async () => {
    if (!file) return toast.error("Choose a CSV file");
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post(`/campaigns/${campaignId}/import-csv`, fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success(
        data.updated
          ? `${data.imported} new · ${data.updated} updated`
          : `Imported ${data.imported} posts`
      );
      onOpenChange(false);
      setFile(null);
      onDone?.();
    } catch (err) {
      toast.error(apiError(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="import-csv-dialog" className="max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Import CSV</DialogTitle>
          <DialogDescription>
            Upload a CSV export (CreatorName, Views, Likes, Comments, Shares, Video Link, Published date).
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <button
            data-testid="csv-dropzone"
            onClick={() => inputRef.current?.click()}
            className="flex w-full flex-col items-center gap-2 rounded-xl border-2 border-dashed border-neutral-300 p-8 text-center transition-colors hover:bg-neutral-50"
          >
            <FileUp className="h-7 w-7 text-neutral-400" />
            <span className="text-sm font-medium text-neutral-700">{file ? file.name : "Click to choose CSV"}</span>
            <span className="text-xs text-neutral-400">.csv export</span>
          </button>
          <input
            ref={inputRef}
            data-testid="input-csv-file"
            type="file"
            accept=".csv,text/csv"
            className="hidden"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
          />
          <Button data-testid="submit-import-csv" onClick={submit} disabled={saving} className="w-full rounded-full bg-[#35606E] py-6 hover:bg-[#294b57]">
            {saving && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Import Posts
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
